<template>
    <div>
        <nsw-menu v-show="showMenu"></nsw-menu>
        <breadcrumb
            :main_cate_title="cateTitle"
            :sub_cate_title="subcateTitle"
            :isShowFilter="isShowFilter"
            :total_resources="storeResource.total_resources"
        >
        </breadcrumb>
        <div slot="search-result" :total_resources="storeResource.total_resources"></div>
        <div slot="filter-control"></div>
        <div
            class="basic-message-box"
            v-show="storeResource.total_resources === 0"
        >
            <p>{{ lang($t("Coming soon")) }}</p>
        </div>


        <template v-if="storeResource.content_type === 'single'">
            <div class="content-wrapper resources" v-show="storeResource.total_resources > 0" >
                <h3 class="title-head">{{ storeResource.table_heading }}</h3>

                    <div class="obj-resources-table">
                        <!--thead-->
                        <SubCateListTableHeading
                                v-bind:table_key="-1"
                        ></SubCateListTableHeading>
                        <!--tbody-->
                        <ResourceListItem
                                v-bind:cate_list="storeResource.cate_list"
                        ></ResourceListItem>
                        <!---end tbody-->
                    </div>


            </div>
        </template>
        <template v-else="content_type === 'group'">
            <div v-show="storeResource.total_resources > 0">
                <div class="content-wrapper resources"
                     v-for="(resources, table_key) in storeResource.cate_list"
                     v-show="getGroupResourceTotal(resources) > 0"
                >
                    <h3 class="title-head">{{ resources.heading }}</h3>

                        <div class="obj-resources-table">
                            <!--thead-->
                            <SubCateListTableHeading
                                    v-bind:table_key="table_key"
                            ></SubCateListTableHeading>
                            <!--tbody-->
                            <ResourceListItem
                                    v-bind:cate_list="resources.resource"
                            ></ResourceListItem>
                            <!---end tbody-->
                        </div>

                </div>
            </div>
        </template>

        <subcate-footer v-show="showMyDownload"></subcate-footer>
    </div>

</template>

<script>
    //TODO: user path alias
    import Vue from 'vue';
    import axios from 'axios';
    import router from '@js/routes';
    import {common} from '@mixins/common';
    import {storeMapper} from '@mixins/storeMapper';
    import api from '@js/api';
    import EventBus from '@common/eventBus';
    import HkepCheckBox from '@/HkepCheckBox';
    import HkepLabel from '@/HkepLabel';
    import HkepDisplayFormatSize from '@/HkepDisplayFormatSize';
    import SubCateListTableHeading from '@/SubCateListTableHeading';
    import ResourceListItem from '@/ResourceListItem';

    export default {
        name: "ResourceList",
        mixins:[common, storeMapper],
        components: {
            HkepCheckBox,
            HkepLabel,
            HkepDisplayFormatSize,
            SubCateListTableHeading,
            ResourceListItem
        },
        data: function() {
            return {
                content_type: "single",
                subCateId:null, //the subcate id for getting the resource data
                cateTitle:null, //main cate title
                //cateBgColor:null, //main cate background color; used to display on breadcrumb (on desktop screen)
                subcateTitle:null, //sub cate title
                isShowFilter:false, //whether show the filter button or not)
                showMyDownload: true,
                showCheckBox: true,
                showMenu: true
            }
        },
        /**
         * 當路由有更新, 例如 [YOUR_IP:PORT]/sub_cate_list?id=XXX 當中的 URL query param XXX 轉變時,beforeRouteUpdate 會 listen;
         * sub cate id 有更新後只要再 fetchData 便可; fetchData 裏會讀取 URL query param
         */
        beforeRouteUpdate (to, from, next) {
            next();
            this.fetchData();
        },
        /**路由相處理
         * 第一次進入本頁面時的動作。
         * @param to
         * @param from
         * @param next
         */
        beforeRouteEnter (to, from, next) {

            //Note in this route guard, access 'this' using vm (e.g. vm.fetchData() will trigger this.fetchData()
            next(vm=> {

                EventBus.$emit("showGlobalLoading");
                Promise.all(
                    [
                        api.getMainCate(),
                        api.getDownloadData()
                    ]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                    .map(p => p.catch(() => undefined)))
                    .then(axios.spread((responseMainCate, responseDownloadData) => {

                        if (responseMainCate) {
                            vm.setWebSiteAndCate( responseMainCate.data, vm);
                        }

                        if (responseDownloadData) {
                            vm.$store.commit("my_download_store/updateData", responseDownloadData.data);
                        }

                        vm.fetchData();
                    }))
                /*.catch(error=>{
                       //Handle errors here if something is expected to precess here
                   });
                   */


            });
        },
        mounted() {


            if (this.$route.query.show_m == "no") {
                this.showMenu = false;
            }

            if (this.$route.query.show_header == "no") {
                EventBus.$emit("hideHeader");
            }

        },
        methods: {
            fetchData() {
                let self = this;
                this.subCateId = this.$route.params.subcate_id;

                if (!this.subCateId) {
                    router.push({ name: 'NotFound' });
                }

                EventBus.$emit("showGlobalLoading");

                api.getResourcePageFrontendById(this.subCateId).then(resp=> {


                    //處理是否需要登入的狀態
                    //需辰登入 和 用戶尚未登入
                    if (resp.data.required_login !== undefined) {
                        if (resp.data.required_login && !access_token) {

                            router.push({ name: 'Home' });


                            //不需要登入 和 用戶尚未登入
                        } else if (!resp.data.required_login && !access_token) {

                            self.showMyDownload = false;
                            self.showCheckBox = false

                        }
                    }


                    this.$store.commit("resource_store/setCateData", {
                        cate_title: resp.data.col_title,
                        cate_list:  resp.data.resources,
                        table_heading:resp.data.table_heading,
                        total_resources:resp.data.count,
                        content_type:resp.data.content_type,
                        mobile_order:resp.data.mobile_order,
                        filter:resp.data.filter,
                        download_display_type: resp.data.download_display_type,
                        show_check_box: self.showCheckBox
                    });

                    if (this.storeResource.content_type === 'group') {
                        for(var key=0; key < this.storeResource.cate_list.length; key++ ) {
                            this.storeResource.check_all_group_resource[key] = false;
                        }
                    }

                    if (this.checkIsShowFilter()) {
                        EventBus.$emit("setCriteria", resp.data.filter);
                    }

                    this.updateRelationUrl(this.subCateId);

                }).catch(function (resp) {

                    router.push({ name: 'NotFound' });

                    EventBus.$emit("hideGlobalLoading");
                //catch 之後的 then(), 無論 axios 成功或是失敗, 總會執行
                }).then(()=> {


                    this.resetMainAppSize();

                    Vue.nextTick(()=>{
                        if(window.MathJax) {
                            window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => {
                                EventBus.$emit("closeMobileMenu");
                                EventBus.$emit("hideGlobalLoading");
                            });
                        }
                    });

                });

                //當用戶點擊add to inventory button之後發生的事件
                EventBus.$on('unselect_all_subcate', ()=> {
                    if (this.storeResource.content_type === 'single') {
                        this.storeResource.cate_list.forEach(function(item, index) {
                            if (item.allow_download === true && item.allow_use === true) {
                                Vue.set(item, 'check', false);
                            }

                        });
                    } else {
                        this.storeResource.cate_list.forEach(function(item, index) {
                            item.resource.forEach(function(resource_item) {
                                if (resource_item.allow_download === true && resource_item.allow_use === true) {
                                    Vue.set(resource_item, 'check', false);
                                }
                            });
                        });
                    }

                });
            },
            /**
             * Get the individual group resource total,
             * so that the entire group can be hidden if no result after filtering
             */
            getGroupResourceTotal(resources)
            {

                let dispalyable = resources.resource.filter(el=>{
                    return el.is_filtered === null || el.is_filtered === false;
                });

                return dispalyable.length
            },
            /**
             * Check to see if at least one criteria has options. If not, don't display the filter button
             */
            checkIsShowFilter() {

                if (!this.storeResource.total_resources) {
                    return;
                }

                let classificationCount = 0;

                for (let item of this.storeResource.filter) {
                    if (item.classification && item.options) {
                        classificationCount++;
                    }
                }

                if (classificationCount > 0) {
                    this.isShowFilter = true;
                    return true;
                }

                return false;

            }
        }
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ResourceList.vue